import classNames from "classnames";
import React, { FunctionComponent } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { ReactComponent as CheckIcon } from "@Icons/check.svg";
import { Price } from "@Types/api/price";
import "./style.scss";

interface Props {
  isSelected: boolean;
  onSelectChange: () => void;
  upsell: {
    description: string;
    imageUrl: string;
    price: Price;
    title: string;
  };
}

const UpsellItemMobile: FunctionComponent<Props> = ({ isSelected, onSelectChange, upsell }) => {
  const intl = useIntl();
  const priceFormated = intl.formatNumber(upsell.price.cents, {
    currency: upsell.price.currency,
    style: "currency",
  });

  return (
    <div
      className={classNames("UpsellItemMobile", {
        "UpsellItemMobile--selected": isSelected,
      })}
    >
      <img className="UpsellItemMobile-image" src={upsell.imageUrl} alt={upsell.title} />
      <div className="UpsellItemMobile-infos">
        <div className="UpsellItemMobile-title">
          <div className="UpsellItemMobile-name">{upsell.title}</div>
          <div className="UpsellItemMobile-price">{priceFormated}</div>
        </div>
        <div className="UpsellItemMobile-description">{upsell.description}</div>
        <button onClick={onSelectChange} className="UpsellItemMobile-button">
          {isSelected ? (
            <>
              <CheckIcon />
              <FormattedMessage id={"cheerz_UpsellsMobile_added_upsell"} />
            </>
          ) : (
            <FormattedMessage id={"cheerz_UpsellsMobile_add_upsell"} />
          )}
        </button>
      </div>
    </div>
  );
};

export default UpsellItemMobile;
